/* Native Shopify signup with consent-aware measurement and configurable offer allocation. */
(() => {
  'use strict';
  const dialog = document.getElementById('smc-studio-popup');
  if (!dialog || typeof dialog.show !== 'function') return;
  const params = new URLSearchParams(location.search);
  const preview = ['a','b'].includes(params.get('smc_popup_preview'));
  const experiment = dialog.dataset.experiment;
  const offerOnly = dialog.dataset.mode === 'offer-only' && !preview;
  const reportTag = /^smc-popup-[a-z0-9-]+$/.test(dialog.dataset.reportTag || '') ? dialog.dataset.reportTag : '';
  const assignmentKey = experiment === 'studio-popup-v2' ? 'smc:studio:experiment:v2' : `smc:studio:experiment:${experiment}`;
  const form = dialog.querySelector('form');
  const backdrop = document.getElementById('smc-studio-backdrop');
  const reopen = document.getElementById('smc-studio-reopen');
  const inline = document.getElementById('smc-studio-inline');
  const result = dialog.querySelector('[data-studio-result]');
  const country = /^[A-Z]{2}$/.test(dialog.dataset.country || '') ? dialog.dataset.country : 'ZZ';
  const currency = /^[A-Z]{3}$/.test(dialog.dataset.currency || '') ? dialog.dataset.currency : 'NZD';
  const summer = ['NZ','AU'].includes(country);
  const northern = 'US CA GB IE FR DE ES IT NL BE AT CH DK SE NO FI IS PL PT GR CZ HU RO BG HR SI SK EE LV LT LU MT CY JP KR HK TW CN AE'.split(' ').includes(country);
  const edition = summer ? 'summer' : northern ? 'autumn-winter' : 'choice';
  const editionName = summer ? 'Summer' : northern ? 'Autumn / Winter' : 'Seasonal';
  const offerReady = dialog.dataset.offerReady === 'true' && /^[A-Z0-9-]{4,32}$/.test(dialog.dataset.offerCode || '');
  const key = assignmentKey, preferenceKey = 'smc:studio:quiet', pendingKey = 'smc:studio:pending:v2';
  const submitButton = form.querySelector('[type="submit"]');
  const signupStatus = form.querySelector('[data-studio-status]');
  const retryProtection = form.querySelector('[data-studio-retry]');
  function offerLabel() {
    const base = Number(dialog.dataset.offerNzd), rate = Number(window.Shopify?.currency?.rate);
    if (!Number.isFinite(base) || base <= 0) return 'A first-order welcome';
    if (currency === 'NZD') return `NZ$${base} off`;
    if (window.Shopify?.currency?.active !== currency || !Number.isFinite(rate) || rate <= 0) return `NZ$${base} off in your currency`;
    const amount = Math.round(base * rate);
    return `About ${new Intl.NumberFormat('en-NZ',{style:'currency',currency,maximumFractionDigits:0}).format(amount)} off`;
  }
  const day = 86400000;
  const measurement = 'popup-2026-10-07';
  let eventMeasurement = measurement;
  const engagedSurfaces = new Set();
  let assignment = null, variant = preview ? params.get('smc_popup_preview') : offerOnly ? 'a' : 'b';
  let format = !offerOnly && params.get('smc_popup_format') === 'slideout' ? 'slideout' : 'modal', surface = 'automatic', palette = '';
  const palettes = {ocean:{name:'Ocean blues',handle:'ocean-blues'},forest:{name:'Forest greens',handle:'forest-greens'},earth:{name:'Earthy hues',handle:'earthy-hues'},neutral:{name:'Soft neutrals',handle:'soft-neutrals'}};
  const manual = () => ['inline','palette'].includes(surface);
  let shown = false, ready = false, previousFocus = null, accepted = false;
  // A random receipt joins a consented submission to Shopify even if the shopper
  // leaves before the success page loads. Never put an email in analytics.
  let signupReceipt = null;
  const storage = (name, method, k, value) => { try { return window[name][method](k,value); } catch { return null; } };
  const read = (name,k) => { try { return JSON.parse(storage(name,'getItem',k)); } catch { return null; } };
  // Preview tabs stay QA-only when following ordinary storefront links.
  const qaSession = preview || storage('sessionStorage','getItem','smc:studio:qa') === 'true';
  if (preview) storage('sessionStorage','setItem','smc:studio:qa','true');
  const privacy = () => window.Shopify?.customerPrivacy;
  const analytics = () => privacy()?.analyticsProcessingAllowed() === true;
  const preferences = () => privacy()?.preferencesProcessingAllowed() === true;
  const dismissalCookie = 'smc_studio_dismissed_until';
  const dismissedUntil = () => { try { return Number(document.cookie.split(';').map(value=>value.trim()).find(value=>value.startsWith(dismissalCookie+'='))?.slice(dismissalCookie.length+1)) || 0; } catch { return 0; } };
  const quiet = () => Math.max(dismissedUntil(), Number(storage('sessionStorage','getItem',preferenceKey)) || 0, preferences() ? Number(storage('localStorage','getItem',preferenceKey)) || 0 : 0) > Date.now();
  const subscribedHere = () => accepted || Math.max(Number(storage('sessionStorage','getItem',preferenceKey)) || 0, preferences() ? Number(storage('localStorage','getItem',preferenceKey)) || 0 : 0) > Date.now()+30*day;
  function rememberQuiet(days) {
    const until = String(Date.now() + days*day);
    storage('sessionStorage','setItem',preferenceKey,until);
    if (preferences()) storage('localStorage','setItem',preferenceKey,until);
  }
  function rememberDismissal() {
    rememberQuiet(30);
    // This stores only the visitor's explicit close preference, never an analytics identity.
    try { document.cookie = `${dismissalCookie}=${Date.now()+30*day}; Max-Age=${30*86400}; Path=/; SameSite=Lax; Secure`; } catch { /* Session storage remains a fallback. */ }
  }
  function setCopy() {
    if (!offerReady) variant = 'b';
    dialog.dataset.variant = variant;
    dialog.dataset.format = format;
    const offer = variant === 'a';
    const hero = dialog.querySelector('img');
    if (!hero.dataset.original) hero.dataset.original = hero.src;
    hero.src = offer ? hero.dataset.original : `${dialog.dataset.guideBase}/${summer || !northern ? 'summer' : 'autumn-winter'}-cover.jpg`;
    hero.alt = offer ? 'Handmade ceramic wall art by Sam Mayell' : `${editionName} styling guide by Sam Mayell Ceramics`;
    dialog.querySelector('#smc-studio-title').textContent = offer ? `${offerLabel()}\nyour first order.` : summer ? 'A little summer\nfor your walls.' : northern ? 'Warm up\nyour walls.' : 'Find your colours.\nMake it yours.';
    dialog.querySelector('#smc-studio-title').style.whiteSpace = 'pre-line';
    dialog.querySelector('#smc-studio-copy').textContent = offer ? 'Find a piece that feels like you. Join my studio list for a welcome saving on your first order, plus new glazes and ideas from Queenstown.' : `Explore ${summer ? 'sea blues, garden greens and brighter glazes' : northern ? 'warm earth, forest greens and quiet neutrals' : 'seasonal palettes and handmade ceramics'}. Join my studio list to download your free ${editionName.toLowerCase()} styling guide.`;
    if (palettes[palette] && !offer) dialog.querySelector('#smc-studio-copy').textContent = `Love ${palettes[palette].name.toLowerCase()}? Join my studio list for your seasonal styling guide and a link to explore this colour collection.`;
    if (!submitButton.disabled) submitButton.textContent = offer ? 'Get my first-order offer \u2197' : 'Get my free guide \u2197';
    const terms = dialog.querySelector('[data-studio-terms]');
    terms.hidden = !offer;
    terms.textContent = `NZ$${dialog.dataset.offerNzd} off, converted at checkout. First order only, once per customer. Cannot combine with other discounts. Use the email you sign up with.`;
    dialog.querySelector('[data-studio-tags]').value = qaSession ? 'newsletter,smc-popup-qa' : `newsletter,smc-popup-v2-${manual() ? surface : assignment && analytics() ? variant : 'unmeasured'},smc-popup-v2-${offer ? 'offer' : 'guide'},smc-popup-format-${format},smc-popup-country-${country.toLowerCase()},smc-popup-guide-${edition}${palettes[palette] ? ',smc-palette-'+palette : ''}${reportTag ? ','+reportTag+'-'+(manual() ? surface : assignment && analytics() ? variant : 'unmeasured') : ''}`;
    if (signupReceipt && analytics()) dialog.querySelector('[data-studio-tags]').value += ',smc-popup-receipt-'+signupReceipt;
  }
  function fulfil(pending) {
    const offer = pending.variant === 'a' && offerReady;
    const selected = ['summer','autumn-winter'].includes(pending.edition) ? pending.edition : 'summer';
    const other = selected === 'summer' ? 'autumn-winter' : 'summer';
    const names = {'summer':'Summer','autumn-winter':'Autumn / Winter'};
    const guide = dialog.querySelector('[data-studio-guide]'), alternate = dialog.querySelector('[data-studio-alternate]'), code = dialog.querySelector('[data-studio-code]');
    guide.hidden = offer; alternate.hidden = offer; code.hidden = !offer;
    dialog.querySelector('[data-studio-fulfilment]').textContent = offer ? 'Your welcome code is ready. Apply it below, then use the same email at checkout. Your first-order eligibility is checked there.' : 'Your guide is ready. Download it below and find a palette for your home.';
    code.textContent = dialog.dataset.offerCode;
    guide.href = `${dialog.dataset.guideBase}/sam-mayell-${selected}-2026.pdf`;
    guide.textContent = `Download the ${names[selected]} guide \u2197`;
    alternate.href = `${dialog.dataset.guideBase}/sam-mayell-${other}-2026.pdf`;
    alternate.textContent = `Prefer ${names[other].toLowerCase()}? Get that edition`;
    const shop = dialog.querySelector('[data-studio-shop]');
    shop.href = offer ? `/discount/${encodeURIComponent(dialog.dataset.offerCode)}?redirect=%2Fcollections%2Fceramic-wall-art-sets-domes-checkers-amp-mixed-collections` : '/collections/ceramic-wall-art-sets-domes-checkers-amp-mixed-collections';
    shop.textContent = offer ? 'Apply my code & explore \u2197' : 'Explore the wall art \u2197';
    if (!offer && palettes[pending.palette]) {
      shop.href = '/collections/'+palettes[pending.palette].handle;
      shop.textContent = `Explore ${palettes[pending.palette].name.toLowerCase()} \u2197`;
    }
  }
  function assign() {
    if (offerOnly) { variant = 'a'; format = 'modal'; }
    if (preview || !analytics() || !offerReady) return;
    const saved = read('localStorage',key);
    if (saved && /^[a-f0-9-]{36}$/.test(saved.visitor) && ['a','b'].includes(saved.variant) && saved.expires > Date.now() && (!offerOnly || (saved.variant === 'a' && saved.format === 'modal'))) assignment = saved;
    else if (window.crypto?.randomUUID) {
      assignment = {visitor:crypto.randomUUID(),variant:offerOnly ? 'a' : crypto.getRandomValues(new Uint32Array(1))[0] < 2147483648 ? 'a':'b',format:offerOnly ? 'modal' : crypto.getRandomValues(new Uint32Array(1))[0] < 2147483648 ? 'modal':'slideout',market:country,edition,expires:Date.now()+90*day};
      storage('localStorage','setItem',key,JSON.stringify(assignment));
      if (read('localStorage',key)?.visitor !== assignment.visitor) assignment = null;
    }
    if (assignment) {variant = assignment.variant;format = assignment.format === 'slideout' ? 'slideout' : 'modal';}
  }
  function track(event) {
    if (preview || !assignment || !analytics()) return;
    const body = JSON.stringify({experiment,variant,format,surface,visitor:assignment.visitor,market:assignment.market || country,edition:assignment.edition || edition,event,analyticsConsent:true,test:qaSession,...(eventMeasurement ? {measurement:eventMeasurement} : {}),...(['submitted','accepted'].includes(event) && signupReceipt ? {receipt:signupReceipt} : {}),automated:window.navigator?.webdriver === true,device:matchMedia('(max-width:640px)').matches?'mobile':'desktop'});
    // A failure never blocks shopping or the native subscription. Reporting deduplicates retries.
    fetch(dialog.dataset.endpoint,{method:'POST',headers:{'Content-Type':'text/plain'},body,credentials:'omit',keepalive:true}).then(r=>{
      if (!r.ok) throw Error('Analytics unavailable');
      dialog.dataset.lastRecorded = event;
    }).catch(()=>{ dialog.dataset.trackingStatus = 'unavailable'; });
  }
  // Trusted input is a diagnostic, never a substitute for all exposed shoppers.
  // Do not send input values, pointer positions, keys, or an identifier without consent.
  function recordEngagement(event) {
    if (event.isTrusted !== true || !dialog.open || document.hidden || accepted || engagedSurfaces.has(surface) || !assignment || !analytics()) return;
    engagedSurfaces.add(surface); track('engaged');
  }
  document.addEventListener('pointerdown',recordEngagement,true);
  document.addEventListener('keydown',recordEngagement,true);
  function close() {
    if (!dialog.open) return;
    if (!preview) { if (accepted) rememberQuiet(365); else { rememberDismissal(); track('dismissed'); } }
    dialog.close(); backdrop.hidden = true;
    if (reopen) reopen.hidden = subscribedHere() || !ready;
    previousFocus?.focus?.({preventScroll:true});
  }
  function busy() {
    return [...document.querySelectorAll('dialog[open]:not(#smc-studio-popup),[aria-modal="true"]:not(#smc-studio-popup),[aria-expanded="true"][aria-controls*="cart"]')].some(el=>el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '') || privacy()?.shouldShowBanner?.() === true;
  }
  let captchaState = 'idle', captchaAttempt = 0, captchaTimer, submitTimer, submitting = false;
  function signupMessage(message, retry = false) {
    if (signupStatus) { signupStatus.textContent = message; signupStatus.hidden = !message; }
    if (retryProtection) retryProtection.hidden = !retry;
  }
  function prepareCaptcha() {
    if (['loading','ready'].includes(captchaState) || !window.Shopify?.captcha?.protect) return;
    captchaState = 'loading';
    const attempt = ++captchaAttempt;
    submitButton.disabled = true; submitButton.textContent = 'Preparing signup\u2026';
    signupMessage('');
    const failed = () => {
      if (attempt !== captchaAttempt || captchaState === 'ready') return;
      clearTimeout(captchaTimer);
      captchaState = 'failed';
      submitButton.textContent = 'Signup connection paused';
      signupMessage('The signup connection is taking longer than expected. Retry below; your email stays here.', true);
    };
    captchaTimer = setTimeout(failed, 15000);
    try {
      // Shopify owns token creation and submission; never call the provider directly.
      window.Shopify.captcha.protect(form, () => {
        if (attempt !== captchaAttempt) return;
        clearTimeout(captchaTimer);
        captchaState = 'ready'; submitButton.disabled = false;
        signupMessage(''); setCopy();
      });
    } catch { failed(); }
  }
  retryProtection?.addEventListener('click', prepareCaptcha);
  function open({restoring=false,requested=false} = {}) {
    if (dialog.open || (shown && !requested && !restoring) || (!preview && !restoring && !requested && (quiet() || busy() || document.hidden))) return;
    if (!accepted) prepareCaptcha();
    if (!restoring && !requested) assign();
    setCopy(); previousFocus = document.activeElement;
    // Keep Shopify's external CAPTCHA panel outside an inert modal top layer.
    backdrop.hidden = format === 'slideout'; dialog.show(); shown = true;
    if (reopen) reopen.hidden = true;
    dialog.setAttribute('aria-modal',format === 'slideout' ? 'false' : 'true');
    // Focus the heading rather than immediately opening a phone keyboard.
    dialog.querySelector('#smc-studio-title').focus({preventScroll:true});
    if (!preview && !restoring) { if (!requested) rememberQuiet(1); track('exposed'); }
  }
  function restore() {
    const pending = read('sessionStorage',pendingKey);
    // Shopify's /challenge return_path can omit the form anchor. Require both
    // our recent pending submission and Shopify's native success result; a URL
    // flag alone must never show the code or count an acceptance.
    const isReturn = location.hash === '#smc-studio-form' || (!location.hash && result.dataset.success === 'true');
    if (!pending || Date.now()-pending.at > 3600000 || !isReturn) return false;
    const sameExperiment = (pending.experiment || 'studio-popup-v2') === experiment;
    signupReceipt = sameExperiment && analytics() && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(pending.receipt || '') ? pending.receipt : null;
    eventMeasurement = sameExperiment && pending.measurement === measurement ? measurement : null;
    variant = ['a','b'].includes(pending.variant) ? pending.variant : 'a';
    format = pending.format === 'slideout' ? 'slideout' : 'modal';
    surface = ['automatic','reopen','inline','palette'].includes(pending.surface) ? pending.surface : 'automatic';
    palette = Object.hasOwn(palettes,pending.palette) ? pending.palette : '';
    assignment = sameExperiment && pending.measured && analytics() ? read('localStorage',key) : null;
    if (!manual() && assignment?.variant !== variant) assignment = null;
    if (result.dataset.success === 'true') {
      accepted = true;
      open({restoring:true});
      fulfil(pending);
      form.hidden = true; dialog.querySelector('[data-studio-thanks]').hidden = false;
      dialog.querySelector('#smc-studio-title').textContent = 'Lovely to have you here.';
      dialog.querySelector('#smc-studio-copy').hidden = true;
      if (!pending.preview) { rememberQuiet(365); track('accepted'); }
      storage('sessionStorage','removeItem',pendingKey);
      return true;
    }
    if (result.dataset.error === 'true') { open({restoring:true}); return true; }
    return false;
  }
  function prepareSubmit(event) {
    if (!form.checkValidity()) return;
    // Capture before Shopify's listener so a double click cannot execute a second
    // verification or record another submission while the first is in flight.
    if (submitting || ['loading','failed'].includes(captchaState)) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (!signupReceipt && analytics() && (assignment || qaSession) && window.crypto?.randomUUID) signupReceipt = crypto.randomUUID();
    setCopy();
    storage('sessionStorage','setItem',pendingKey,JSON.stringify({at:Date.now(),experiment,variant,format,surface,palette,edition,measurement:eventMeasurement,measured:Boolean(assignment && analytics()),receipt:analytics()?signupReceipt:null,preview:qaSession}));
    track('submitted');
    submitting = true;
    submitButton.disabled = true; submitButton.textContent = 'Joining the studio\u2026';
    signupMessage('Just a moment while we securely complete your signup.');
    clearTimeout(submitTimer);
    submitTimer = setTimeout(() => {
      submitting = false; submitButton.disabled = false;
      dialog.dataset.state = 'verification-wait';
      setCopy();
      signupMessage('If a verification window is open, finish it there. Otherwise, try the signup button again. Your email is still here.');
    }, 20000);
    dialog.dataset.state = 'submitting';
    // Never close or hide a live CAPTCHA iframe during submission.
    dialog.setAttribute('aria-modal','false');
  }
  form.addEventListener('submit',prepareSubmit,true);
  dialog.querySelectorAll('[data-studio-close]').forEach(button=>button.addEventListener('click',close));
  backdrop.addEventListener('click',close);
  dialog.addEventListener('keydown',event=>{
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key !== 'Tab' || format === 'slideout' || ['submitting','verification-wait'].includes(dialog.dataset.state)) return;
    const focusable = [...dialog.querySelectorAll('button,a[href],input:not([type=hidden])')].filter(el=>!el.disabled && el.getClientRects().length);
    const first=focusable[0], last=focusable[focusable.length-1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement.id === 'smc-studio-title')) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{ if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();} });
  function enter(source, selectedPalette='') {
    if (!ready || subscribedHere() || dialog.open || busy()) return;
    assign();
    surface = source; palette = Object.hasOwn(palettes,selectedPalette) ? selectedPalette : '';
    if (manual()) { variant = 'b'; format = 'slideout'; }
    open({requested:true});
  }
  reopen?.addEventListener('click',()=>enter('reopen'));
  inline?.querySelectorAll('[data-studio-entry]').forEach(button=>button.addEventListener('click',()=>enter(button.dataset.studioEntry,button.dataset.palette)));
  function initialize() {
    if (restore()) return;
    if (offerOnly && !offerReady) return;
    if (preview) {
      ready = true;
      if (inline) { document.querySelector('main, #main, [role="main"]')?.append(inline); inline.hidden = false; }
      open(); return;
    }
    if (dialog.dataset.enabled !== 'true' || !/^(\/([a-z]{2}(-[a-z]{2})?)?)?\/?$|\/collections(\/|$)|\/products\//i.test(location.pathname)) return;
    dialog.querySelector('img').loading = 'eager';
    ready = true;
    if (inline && !subscribedHere()) { document.querySelector('main, #main, [role="main"]')?.append(inline); inline.hidden = false; }
    if (reopen && quiet() && !subscribedHere()) reopen.hidden = false;
    open();
  }
  document.addEventListener('visitorConsentCollected',()=>{
    if (!analytics()) { assignment = null; signupReceipt = null; storage('localStorage','removeItem',key); if (shown && !accepted) setCopy(); }
    else if (ready && !shown) assign();
  });
  const timer = setInterval(()=>{
    if (shown) { clearInterval(timer); return; }
    // Retry only when a privacy banner, another dialog, or a hidden tab postponed opening.
    if (ready) open();
  },1000);
  if (privacy()) initialize();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],initialize);
  else initialize();
})();
